/*
  RevoRope — reveal on scroll (entradas sutiles al aparecer en viewport).

  Independiente de rr-nav.js (mega-menú/overlay) y rr-carousel.js (coverflow): no
  toca ninguno de ellos. Sólo observa elementos .rr-reveal / .rr-reveal--stagger y
  les añade .is-visible cuando entran en el viewport; toda la animación vive en CSS
  (base.css), sólo transform/opacity.

  Contrato de seguridad (ver base.css "Motion / reveal"):
   - El estado oculto inicial sólo se aplica bajo html.rr-anim, que pone el script en
     línea de <head> únicamente si prefers-reduced-motion NO está activo. Si este
     archivo no se ejecutara, el contenido seguiría visible (sin html.rr-anim) o, si
     hubiera html.rr-anim pero sin IntersectionObserver, lo revelamos todo abajo.
   - Failsafe en 'load': revela lo que quede cerca del viewport, por si el observer
     no se disparó (renders sin scroll, etc.). Nunca deja contenido atascado oculto.
*/
(function () {
  'use strict';

  var root = document.documentElement;

  // Sin arma (reduced-motion o JS que no llegó a poner la clase) => no hacemos nada:
  // el contenido ya es visible por defecto.
  if (!root.classList.contains('rr-anim')) return;

  // Sin IntersectionObserver: revelar todo de golpe (sin animación de entrada).
  if (!('IntersectionObserver' in window)) {
    root.classList.remove('rr-anim');
    return;
  }

  var SEL = '.rr-reveal, .rr-reveal--stagger';

  function pending() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (el) {
      return !el.classList.contains('is-visible');
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function observeAll() {
    pending().forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Failsafe: tras cargar del todo, revela lo que ya esté (o casi) en pantalla por si
  // el observer no llegó a marcarlo. No fuerza lo que está muy abajo (se revela al
  // hacer scroll).
  window.addEventListener('load', function () {
    setTimeout(function () {
      var vh = window.innerHeight || 0;
      pending().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 1.15) {
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, 180);
  });
})();
